module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "wrapper-content animated fadeInRight tabBox",
    attrs: {
      "id": "billing-list",
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("救援公司")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryParam.customerIds),
      expression: "queryParam.customerIds"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.levv == 3
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.queryParam, "customerIds", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.groupList), function(item) {
    return _c('option', {
      key: item.id + 'grouplist',
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.groupName))])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("结算状态")]), _vm._v(" "), _vm._l((_vm.udcList), function(item, index) {
    return _c('div', {
      key: 'billing' + index,
      staticClass: "col-sm-1 control-label"
    }, [_c('checkbox', {
      key: index,
      staticStyle: {
        "line-height": "100%",
        "bottom": "0"
      },
      model: {
        value: (item.isChecked),
        callback: function($$v) {
          _vm.$set(item, "isChecked", $$v)
        },
        expression: "item.isChecked"
      }
    }, [_vm._v(_vm._s(item.udcname))])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("救援时间范围(起)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    class: {
      'form-group--error': !_vm.validDates
    }
  }, [_c('datepicker', {
    staticClass: "form-control",
    model: {
      value: (_vm.queryParam.startTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTime", $$v)
      },
      expression: "queryParam.startTime"
    }
  }), _vm._v(" "), (!_vm.validDates) ? _c('p', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("开始时间不得大于结束时间")]) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("救援时间范围(止)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    class: {
      'form-group--error': !_vm.validDates
    }
  }, [_c('datepicker', {
    staticClass: "form-control",
    model: {
      value: (_vm.queryParam.endTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTime", $$v)
      },
      expression: "queryParam.endTime"
    }
  }), _vm._v(" "), (!_vm.validDates) ? _c('p', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("开始时间不得大于结束时间")]) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_c('a', {
    on: {
      "click": _vm.lastSeason
    }
  }, [_vm._v("上一季度")])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_c('a', {
    on: {
      "click": _vm.nowSeason
    }
  }, [_vm._v("当前季度")])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_c('a', {
    on: {
      "click": _vm.lastMonth
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_c('a', {
    on: {
      "click": _vm.nowMonth
    }
  }, [_vm._v("本月")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 t_right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.toSearch
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])])]), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-froup t_right"
  }, [_c('button', {
    staticClass: "btn btn-primary pd10",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("报表导出")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table mb0px table-striped table-bordered table-hover",
    staticStyle: {
      "min-width": "1600px"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("救援单号")]), _vm._v(" "), _c('th', [_vm._v("救援状态")]), _vm._v(" "), _c('th', [_vm._v("救援请求时间")]), _vm._v(" "), _c('th', [_vm._v("抵达耗时(分钟)")]), _vm._v(" "), _c('th', [_vm._v("救援结束时间")]), _vm._v(" "), _c('th', [_vm._v("救援类型")]), _vm._v(" "), _c('th', [_vm._v("被救援车牌号")]), _vm._v(" "), _c('th', [_vm._v("救援公司")]), _vm._v(" "), _c('th', [_vm._v("救援司机姓名")]), _vm._v(" "), _c('th', [_vm._v("救援车牌号")]), _vm._v(" "), _c('th', [_vm._v("救援费用(¥)")]), _vm._v(" "), (_vm.levv == 2) ? _c('th', [_vm._v("救援费用结算状态")]) : _vm._e(), _vm._v(" "), (_vm.levv != 2) ? _c('th', [_vm._v("平台费用(¥)")]) : _vm._e(), _vm._v(" "), (_vm.levv != 2) ? _c('th', [_vm._v("平台费用结算状态")]) : _vm._e()])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list-complete",
      "tag": "tbody"
    }
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('tr', {
      key: 'billingData' + 'index',
      staticClass: "list-complete-item",
      attrs: {
        "key": index
      }
    }, [_c('td', [_vm._v(_vm._s(item.idStr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rescueStatusStr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.requestTimeStr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sceneElapsedTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.finishTimeStr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rescueTypeStr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rescuedPlateNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.driverName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.plateNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.closingCostStr))]), _vm._v(" "), (_vm.levv == 2) ? _c('td', [_vm._v(_vm._s(item.rescueClosingStatusStr))]) : _vm._e(), _vm._v(" "), (_vm.levv != 2) ? _c('td', [_vm._v(_vm._s(item.platformPriceStr))]) : _vm._e(), _vm._v(" "), (_vm.levv != 2) ? _c('td', [_vm._v(_vm._s(item.platformClosingStatusStr))]) : _vm._e()])
  }), 0)], 1)])]), _vm._v(" "), (_vm.dataList.length > 0) ? _c('pagination', {
    attrs: {
      "pageInfo": _vm.pageInfo
    },
    on: {
      "getData": _vm.getPageNo
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label t_left"
  }, [_vm._v("本时间段内累计救援次数："), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.totalCount))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3 control-label t_left"
  }, [_vm._v("统计时间范围:"), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.startTimeStr))]), (this.startTimeStr != '' || this.finishTimeStr != '') ? _c('span', [_vm._v("至")]) : _vm._e(), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.finishTimeStr))])])]), _vm._v(" "), (_vm.levv != 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label t_left"
  }, [_vm._v("本时间段内累计平台费用："), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.totalPriceStr))]), (this.totalPriceStr != '') ? _c('span', [(this.totalPriceStr != '') ? _c('span', [_vm._v("(¥)")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.levv == 3 || _vm.levv == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label t_left"
  }, [_vm._v("本时间段内累计救援费用："), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.totalClosingCostStr))]), (this.totalClosingCostStr != '') ? _c('span', [_vm._v("(¥)")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.levv == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label t_left"
  }, [_vm._v("计费周期内平台累计救援次数："), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.totalRescueTime))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3 control-label t_left"
  }, [_vm._v("统计时间范围："), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.startTime))]), (this.startTime != '' || this.endTime != '') ? _c('span', [_vm._v("至")]) : _vm._e(), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.endTime))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3 control-label t_left"
  }, [_vm._v("状态："), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(_vm.currentCostStatus))])])]) : _vm._e(), _vm._v(" "), (_vm.levv == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label t_left"
  }, [_vm._v("计费周期内平台累计平台费用："), _c('span', {
    staticStyle: {
      "color": "#F23F3C"
    }
  }, [_vm._v(_vm._s(this.totalPlatformCost))]), (this.totalPlatformCost != '') ? _c('span', [_vm._v("(¥)")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("费用包含结算状态：")]), _vm._v(" "), _vm._l((_vm.udcTotalList), function(item, index) {
    return _c('div', {
      key: 'udctotal' + index,
      staticClass: "col-sm-1 control-label"
    }, [_c('checkbox', {
      key: index,
      staticStyle: {
        "line-height": "100%",
        "bottom": "0"
      },
      on: {
        "change": _vm.loadDataForDidi
      },
      model: {
        value: (item.isChecked),
        callback: function($$v) {
          _vm.$set(item, "isChecked", $$v)
        },
        expression: "item.isChecked"
      }
    }, [_vm._v(_vm._s(item.udcname))])], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsg
    }
  }, [_vm._v("\n                " + _vm._s(_vm.messageStr) + "\n                "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsg
    }
  }, [_vm._v("确定")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e3120da","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/billingmanagement/PageBillingList.vue
// module id = 1536
// module chunks = 0